module.exports = __webpack_public_path__ + "static/media/img_howto_phone_illust2@2x.7c1da3d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_howto_phone_illust2@2x.png
// module id = 1091
// module chunks = 0